import { MenuDownOutlineIcon } from './MenuDownOutlineIcon';

/**
 * author: Austin Andrews
 * id EE6F8AAE-7856-4E4C-AC01-3589A2C66D98
 * name menu-down-outline
 * version: 1.7.22
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/menu-down-outline.svg
 * tags
 * - Arrow 
 */
export const CaretDownOutlineIcon = MenuDownOutlineIcon;
export default CaretDownOutlineIcon